export default "__VITE_ASSET__BSxvll2d__"